import { apiFetch } from "../utils/apiUtils";

export interface BetaStatus {
    beta: boolean;
    rank?: number;
    total?: number;
}

export async function fetchBetaStatus(): Promise<BetaStatus> {
    const res = await apiFetch("api/v1/beta/status");
    if (!res.ok) {
        return { beta: false };
    }
    return res.json();
}
